import styled from '@emotion/styled'

const StyleBox = styled.div`
  border-width: 1px;
  border-style: solid;
  padding: 0.875rem;
  border-radius: 4px;
  width: ${({ width }) => {
    return width
  }};
  height: ${({ height }) => {
    return height
  }};
`

export default StyleBox
